import React from 'react'
import { injectIntl } from 'react-intl'
import {
  Tabs,
  Tab,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@material-ui/core'
import { TABLET_BREAKPOINT } from 'helpers/responsive'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import messages from 'routes/App/Apps/MyJobs/translate'
import { JOB_PRESETS } from '../Common/constants'

function StatusFilter({
  intl: { formatMessage },
  saveActivePreset,
  resetTasks,
  jobTask,
  preset,
  featureFlags,
}) {
  const jobStates = [
    { id: JOB_PRESETS.ACTIVE, name: formatMessage(messages.active) },
    ...(featureFlags?.JOBS_APPROVAL
      ? [{ id: JOB_PRESETS.PENDING, name: formatMessage(messages.pending) }]
      : []),
    { id: JOB_PRESETS.FUTURE, name: formatMessage(messages.future) },
    { id: JOB_PRESETS.COMPLETED, name: formatMessage(messages.completed) },
  ]

  const classes = {
    tabContainer: {
      root: 'job-tabs',
      indicator: 'active-tab',
      flexContainer: 'tabs-container',
    },
    tab: {
      root: 'tab-control',
    },
    formStatusControl: {
      root: 'sf-form-control sf-form-status-control',
    },
    formControlLabel: {
      root: 'sf-form-control-label',
      shrink: 'sf-form-control-label-shrink',
    },
  }

  const handleFilterChange = (event, value) => {
    const { value: targetValue } = event.target
    saveActivePreset(targetValue || value)

    if (jobTask.size > 0) {
      resetTasks()
    }
  }

  return ifWindowWidthLessThan(TABLET_BREAKPOINT) ? (
    <Tabs
      value={preset}
      onChange={handleFilterChange}
      classes={classes.tabContainer}>
      {jobStates.map(jobState => (
        <Tab
          key={jobState.id}
          value={jobState.id}
          label={jobState.name}
          classes={classes.tab}
        />
      ))}
    </Tabs>
  ) : (
    <FormControl fullWidth>
      <InputLabel htmlFor="active-status-list">
        {formatMessage(messages.jobStates)}
      </InputLabel>
      <Select
        value={preset}
        onChange={handleFilterChange}
        inputProps={{
          id: 'active-status-list',
        }}>
        {jobStates.map(jobState => (
          <MenuItem key={jobState.id} value={jobState.id}>
            {jobState.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default injectIntl(StatusFilter)
